import { useConfiguration } from "./WithConfiguration";

export const SmallLogo: React.FC = () => {
  const configuration = useConfiguration();
  if (!configuration.logo) {
    return null;
  }
  return <img className="h-12" src={configuration.circle_logo} />;
};
